import { applySnapshot, destroy, types } from "mobx-state-tree";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import {
  ILoanProcessPlanDetailModel,
  ILoanProcessPlanModel,
  ILoanSourcesModel,
  ILoanTypePlanModel,
  LoanProcessPlanModel,
  LoanSourcePlanModel,
  LoanTypeModel,
  LoanTypePlanModel,
} from "../share/LoanModel";

export const ProceedModel = types
  .model("ProceedModel", {
    detail: customtypes.optional(types.string, ""),
    budget: customtypes.optional(types.number, 0),
    revernue: customtypes.optional(types.number, 0),
    signedLoan: customtypes.optional(types.number, 0),
    disburseLoan: customtypes.optional(types.number, 0),
    other: customtypes.optional(types.number, 0),
    total: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IProceedModel = typeof ProceedModel.Type;

export const ProceedByYearModel = types
  .model("ProceedByYearModel", {
    year: types.optional(ProceedModel, {}),
    months: types.optional(types.array(ProceedModel), []),
  })
  .views((self: any) => ({
    get proceedBudgetTotal() {
      return (
        self.months.reduce(
          (sum: number, proceed: IProceedModel) => sum + proceed.budget,
          0,
        ) + self.year.budget
      );
    },
    get proceedRevernueTotal() {
      return (
        self.months.reduce(
          (sum: number, proceed: IProceedModel) => sum + proceed.revernue,
          0,
        ) + self.year.revernue
      );
    },
    get proceedSignedLoanTotal() {
      return (
        self.months.reduce(
          (sum: number, proceed: IProceedModel) => sum + proceed.signedLoan,
          0,
        ) + self.year.signedLoan
      );
    },
    get proceedDisburseLoanTotal() {
      return (
        self.months.reduce(
          (sum: number, proceed: IProceedModel) => sum + proceed.disburseLoan,
          0,
        ) + self.year.disburseLoan
      );
    },
    get proceedOtherTotal() {
      return (
        self.months.reduce(
          (sum: number, proceed: IProceedModel) => sum + proceed.other,
          0,
        ) + self.year.other
      );
    },
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IProceedByYearModel = typeof ProceedByYearModel.Type;

export interface IAmountObject {
  // ใช้สำหรับตอนทำ SignLoan View จาก loanTypePlans
  sourceType: string;
  amount: number;
  currencyCode: string;
  amountAsMillion: number;
}

export const ResultLOVModel = types
  .model("ResultLOVModel", {
    id: types.optional(types.number, 0),
    code: types.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    description: types.optional(types.string, ""),
    isSelected: types.optional(types.boolean, false),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export type IResultLOVModel = typeof ResultLOVModel.Type;

export const ResultLOVOrNullModel = types
  .model("ResultLOVOrNullModel", {
    id: types.maybeNull(types.number),
    code: types.maybeNull(types.string), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    description: types.maybeNull(types.string),
    isSelected: types.maybeNull(types.boolean),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export type IResultLOVOrNullModel = typeof ResultLOVOrNullModel.Type;

export const ResultLOVModelContract = types
  .model("ResultLOVModelContract", {
    id: customtypes.optional(types.number, 0),
    code: customtypes.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    description: customtypes.optional(types.string, ""),
    isSelected: customtypes.optional(types.boolean, false),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));

export type IResultLOVModelContract = typeof ResultLOVModelContract.Type;

export const AmountModel = types
  .model("AmountModel", {
    sourceType: customtypes.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    amount: customtypes.optional(types.number, 0),
    currencyCode: customtypes.optional(types.string, ""),
    thbAmount: customtypes.optional(types.number, 0),
    sourceLoan: types.optional(ResultLOVModel, {}),
  })
  .views((self: any) => ({
    get mAmount() {
      return self.amount / 1000000;
    },
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IAmountModel = typeof AmountModel.Type;

export const AmountContractModel = types
  .model("AmountContractModel", {
    sourceType: customtypes.optional(types.string, ""), // (L = ในประเทศ , F = ต่างประเทศ, O = อื่นๆ)
    amount: customtypes.optional(types.number, 0),
    currencyCode: customtypes.optional(types.string, ""),
    thbAmount: customtypes.optional(types.number, 0),
    sourceLoan: customtypes.optional(ResultLOVModelContract, {}),
  })
  .views((self: any) => ({
    get mAmount() {
      return self.amount / 1000000;
    },
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type AmountContractModel = typeof AmountContractModel.Type;

export const SaveProceedModel = types
  .model("SaveProceedModel", {
    year: customtypes.optional(types.number, 0),
    month: customtypes.optional(types.number, 0), // เดือน 1-12 (1 = มกราคม) ถ้าเป็นรายปีใส่ 0
    budget: customtypes.optional(types.array(AmountModel), []),
    revernue: customtypes.optional(types.array(AmountModel), []),
    signedLoan: customtypes.optional(types.array(AmountModel), []),
    disburseLoan: customtypes.optional(types.array(AmountModel), []),
    other: customtypes.optional(types.array(AmountModel), []),
  })
  .views((self: any) => ({
    get localBudget(): IAmountModel | undefined {
      return self.budget.find(
        (amount: IAmountModel) => amount.sourceType === "L",
      );
    },
    get localRevernue(): IAmountModel | undefined {
      return self.revernue.find(
        (amount: IAmountModel) => amount.sourceType === "L",
      );
    },
    get localOther(): IAmountModel | undefined {
      return self.other.find(
        (amount: IAmountModel) => amount.sourceType === "L",
      );
    },
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setDefaultBudget: () => {

      if (self.budget.length === 0) {
        self.budget.push({ sourceType: "L", currencyCode: "THB" });
      } else {
        self.budget.splice(1);
      }

    },
    setDefaultRevernue: () => {

      if (self.revernue.length === 0) {
        self.revernue.push({ sourceType: "L", currencyCode: "THB" });
      } else {
        self.revernue.splice(1);
      }

    },
    setDefaultOther: () => {

      if (self.other.length === 0) {
        self.other.push({ sourceType: "L", currencyCode: "THB" });
      } else {
        self.other.splice(1);
      }
    },
  }));
export type ISaveProceedModel = typeof SaveProceedModel.Type;

export const ActivityModel = types
  .model("ActivityModel", {
    projActID: types.maybeNull(types.number),
    activityName: customtypes.optional(types.string, ""),
    resolutionAmounts: types.optional(types.array(AmountModel), [
      // { sourceType: "L", currencyCode: "THB" },
      // { sourceType: "O", currencyCode: "THB" },
      // { sourceType: "F", currencyCode: "USD" },
    ]),
    contractAmounts: customtypes.optional(types.array(AmountContractModel), [
      // { sourceType: "L", currencyCode: "THB" },
      // { sourceType: "O", currencyCode: "THB" },
      // { sourceType: "F", currencyCode: "USD" },
    ]),
    totalResolution: customtypes.optional(types.number, 0),
    totalContract: customtypes.optional(types.number, 0),
    totalProceedByActivity: types.optional(ProceedModel, {}),
    years: types.optional(types.array(ProceedByYearModel), []),
    saveProceedData: types.optional(types.array(SaveProceedModel), []),
    gfCode: customtypes.optional(types.string, ""),
  })
  .views((self: any) => ({
    get yearsProceedBudgetTotal() {
      return self.years.reduce(
        (sum: number, proceed: IProceedByYearModel) =>
          sum + proceed.proceedBudgetTotal,
        0,
      );
    },
    get yearsProceedRevernueTotal() {
      return self.years.reduce(
        (sum: number, proceed: IProceedByYearModel) =>
          sum + proceed.proceedRevernueTotal.revernue,
        0,
      );
    },
    get yearsProceedSignedLoanTotal() {
      return self.years.reduce(
        (sum: number, proceed: IProceedByYearModel) =>
          sum + proceed.proceedSignedLoanTotal,
        0,
      );
    },
    get yearsProceedDisburseLoanTotal() {
      return self.years.reduce(
        (sum: number, proceed: IProceedByYearModel) =>
          sum + proceed.proceedSignedLoanTotal.disburseLoan,
        0,
      );
    },
    get yearsProceedOtherTotal() {
      return self.years.reduce(
        (sum: number, proceed: IProceedByYearModel) =>
          sum + proceed.proceedDisburseLoanTotal.other,
        0,
      );
    },
    get resolutionAmountsSorted() {
      return [
        ...self.resolutionAmounts
        // self.resolutionAmounts.find(
        //   (amount: IAmountModel) => amount.sourceType === "L",
        // ),
        // ...self.resolutionAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "L",
        // ),
        // ...self.resolutionAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "F",
        // ),
        // ...self.resolutionAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "O",
        // ),
        // self.resolutionAmounts.find(
        //   (amount: IAmountModel) => amount.sourceType === "O",
        // ),
      ];
    },
    get contractAmountsSorted() {
      return [
        ...self.contractAmounts

        // self.contractAmounts.find(
        //   (amount: IAmountModel) => amount.sourceType === "L",
        // ),
        // ...self.contractAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "L",
        // ),
        // ...self.contractAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "F",
        // ),
        // ...self.contractAmounts.filter(
        //   (amount: IAmountModel) => amount.sourceType === "O",
        // ),
        // self.contractAmounts.find(
        //   (amount: IAmountModel) => amount.sourceType === "O",
        // ),
            ];
    },
    get activityJSON() {
      return self.toJSON();
    },
  }))
  .actions((self: any) => ({
    onAddForeignAmount: (
      fieldname: "resolutionAmounts" | "contractAmounts",
      sourceType: String | "F",
    ) => {
      self[fieldname].push({
        sourceType: sourceType,
        currencyCode: "USD"
      });
    },
    onAddSourceLoan: (sourceLoan: IResultLOVModel) => {
      self['resolutionAmounts'].push({
        sourceType: 'L',
        currencyCode: "THB",
        sourceLoan,
      });
    },
    onAddSourceLoanContract: (sourceLoan: IResultLOVModel) => {
      self['contractAmounts'].push({
        sourceType: 'L',
        currencyCode: "THB",
        sourceLoan,
      });
    },
    onRemoveAmount: (amount: IAmountModel) => {
      destroy(amount);
    },
    onRemoveForeignAmount: (amount: IAmountModel) => {
      destroy(amount);
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
    setAllField: (data: any) => {
      Object.keys(data).forEach((key) => {
        try {
          self[key] = data[key];
        } catch (e) {
          console.log("exception on mapping key:", key);
        }
      });
    },
    resetAll: () => {
      applySnapshot(self, {});
    },
  }));
export type IActivityModel = typeof ActivityModel.Type;

export type SignLoanMap = Map<string, IAmountObject>;

export const ActivityPlanModel = types
  .model("ActivityPlanModel", {
    description: customtypes.optional(types.string, ""),
    activity: types.optional(ActivityModel, {}),
    activityPlanDetail: types.optional(SaveProceedModel, {}),
    loanTypePlans: types.optional(types.array(LoanTypePlanModel), []),
    loanProcessPlan: types.optional(types.array(LoanProcessPlanModel), []),
  })
  .views((self: any) => ({
    get totalLocalSignLoan(): number | undefined {
      return self.loanTypePlans.length > 0
        ? self.loanTypePlans.reduce(
          (sum: number, loanTypePlan: ILoanTypePlanModel) =>
            sum + loanTypePlan.localLoanPlanAmount,
          0,
        )
        : undefined;
    },
    get totalLocalSignLoanAsMillionBaht(): number {
      return self.totalLocalSignLoan ? self.totalLocalSignLoan / 1000000 : 0;
    },
    get foreignSignLoanSummaryList(): SignLoanMap {
      const totalSignLoanMap: SignLoanMap = new Map();
      // สร้าง List ของ Currency ทั้งหมด
      self.loanTypePlans.forEach((loanTypePlan: ILoanTypePlanModel) => {
        loanTypePlan.foreignLoanPlans.forEach((loanPlan: ILoanSourcesModel) => {
          const loanPlanInMap = totalSignLoanMap.get(loanPlan.currency);
          totalSignLoanMap.set(loanPlan.currency, {
            sourceType: loanPlan.sourceType,
            currencyCode: loanPlan.currency,
            amount: (loanPlanInMap ? loanPlanInMap.amount : 0) + loanPlan.loanAmount,
            amountAsMillion: (loanPlanInMap ? loanPlanInMap.amountAsMillion : 0) + loanPlan.loanAmountAsMillionBaht,
          });
        });
      });
      return totalSignLoanMap;
    },
    get totalOtherSignLoan(): number | undefined {
      return self.loanTypePlans.length > 0
        ? self.loanTypePlans.reduce(
          (sum: number, loanTypePlan: ILoanTypePlanModel) =>
            sum + loanTypePlan.otherLoanPlanAmount,
          0,
        )
        : undefined;
    },
    get totalOtherSignLoanAsMillionBaht(): number {
      return self.totalOtherSignLoan ? self.totalOtherSignLoan / 1000000 : 0;
    },
  }))
  .actions((self: any) => ({
    setSignSummaryLoan: () => {
      console.log("=========setSignSummaryLoan==========");
      // Set signedLoan ที่อยู่ใน activityPlanDetail โดยใช้ foreignSignLoanSummaryList ที่อยู่ใน loanTypePlans
      const foreignSignLoanSummaryAsAmountModel = [];
      self.foreignSignLoanSummaryList.forEach((amount: IAmountObject) => {
        foreignSignLoanSummaryAsAmountModel.push({
          sourceType: amount.sourceType,
          amount: amount.amount,
          currencyCode: amount.currencyCode,
          thbAmount: 0,
        });
      });
      self.activityPlanDetail.signedLoan = self.foreignSignLoanSummaryAsAmountModel;
    },
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IActivityPlanModel = typeof ActivityPlanModel.Type;

export const ActivityPlanSummaryModel = types
  .model("ActivityPlanSummaryModel", {
    budget: customtypes.optional(types.number, 0),
    revernue: customtypes.optional(types.number, 0),
    loan: customtypes.optional(types.number, 0),
    loanSourcePlans: types.optional(types.array(LoanSourcePlanModel), []),
    other: customtypes.optional(types.number, 0),
    total: customtypes.optional(types.number, 0),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IActivityPlanSummaryModel = typeof ActivityPlanSummaryModel.Type;
